// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme CSS Variables */
/* Dark theme is the default */

:root {
    /* Background colors */
    --bg-primary: #000000;
    --bg-secondary: #1a1a1a;
    --bg-card: #111111;
    --bg-tertiary: #0a0a0a;
    --bg-overlay: rgba(0, 0, 0, 0.8);
    --bg-overlay-light: rgba(0, 0, 0, 0.5);

    /* Text colors */
    --text-primary: #ffffff;
    --text-secondary: #cccccc;
    --text-tertiary: #aaaaaa;
    --text-muted: #888888;
    --text-muted-dark: #666666;

    /* Accent colors */
    --accent-primary: #4a90e2;
    --accent-primary-hover: #6aa8ff;
    --accent-gradient-start: #667eea;
    --accent-gradient-end: #764ba2;

    /* Border colors */
    --border-primary: #222222;
    --border-secondary: #2a2a2a;
    --border-tertiary: #333333;
    --border-hover: #4a4a4a;

    /* Card backgrounds */
    --card-gradient-start: #1a1a1a;
    --card-gradient-end: #111111;
    --card-featured-start: #1a2a3a;
    --card-featured-end: #111820;

    /* Warning/Disclaimer */
    --warning-bg: rgba(255, 200, 0, 0.1);
    --warning-border: rgba(255, 200, 0, 0.3);
    --warning-text: #e0e0e0;

    /* Shadows */
    --shadow-card: 0 12px 32px rgba(0, 0, 0, 0.6);
    --shadow-featured: 0 12px 32px rgba(74, 144, 226, 0.3);

    /* Eye component colors */
    --eye-bg: #ffffff;
    --eye-pupil: #000000;
    --eye-border: #cccccc;

    /* Divider */
    --divider-color: #333333;

    /* Hover */
    --bg-hover: #1a1a1a;

    /* Avatar colors */
    --avatar-primary: #8B6914;
    --avatar-secondary: #C4A44A;
    --avatar-inner: #D4B86A;
    --avatar-outline: #4a4a4a;
    --avatar-eye-white: #ffffff;
    --avatar-pupil: #1a1a1a;
    --avatar-eye-shine: rgba(255, 255, 255, 0.9);
    --avatar-eye-ring: #D4C4A0;
    --avatar-nose: #333333;
    --avatar-antler: #6B4E1B;
    --avatar-beak: #E8A020;

    /* Dashboard accent colors — game-inspired vibrant palette */
    --dash-streak: #FF6B35;
    --dash-streak-glow: rgba(255, 107, 53, 0.35);
    --dash-record: #FFD700;
    --dash-record-glow: rgba(255, 215, 0, 0.3);
    --dash-sessions: #38BDF8;
    --dash-sessions-glow: rgba(56, 189, 248, 0.3);
    --dash-points: #A78BFA;
    --dash-points-glow: rgba(167, 139, 250, 0.3);
    --dash-success: #4ADE80;
    --dash-success-glow: rgba(74, 222, 128, 0.3);
    --dash-ring-track: #2a2a2a;
    --dash-ring-fill: #4ADE80;
    --dash-bar-ghost: #2a2a2a;
    --dash-bar-fill: var(--accent-primary);
    --dash-bar-today: #4ADE80;
    --dash-badge-locked-bg: #141414;
    --dash-badge-locked-border: #2a2a2a;
    --dash-badge-new-glow: rgba(255, 215, 0, 0.5);
    --dash-badge-new-glow-wide: rgba(255, 215, 0, 0.15);
    --dash-tooltip-bg: #222222;
    --dash-tooltip-text: #ffffff;
    --dash-warning-cta: #FB923C;

    /* Calendar heatmap — green gradient for dark */
    --cal-level-0-bg: var(--bg-secondary);
    --cal-level-0-text: var(--text-muted);
    --cal-level-1-bg: #1b3a1b;
    --cal-level-1-text: #81c784;
    --cal-level-2-bg: #2e7d32;
    --cal-level-2-text: #ffffff;
    --cal-level-3-bg: #43a047;
    --cal-level-3-text: #ffffff;
    --cal-level-4-bg: #66bb6a;
    --cal-level-4-text: #1b3a1b;
}

/* Light theme */
[data-theme="light"] {
    /* Background colors */
    --bg-primary: #f8f9fa;
    --bg-secondary: #ffffff;
    --bg-card: #ffffff;
    --bg-tertiary: #f0f0f0;
    --bg-overlay: rgba(255, 255, 255, 0.95);
    --bg-overlay-light: rgba(255, 255, 255, 0.8);

    /* Text colors */
    --text-primary: #1a1a1a;
    --text-secondary: #444444;
    --text-tertiary: #666666;
    --text-muted: #888888;
    --text-muted-dark: #777777;

    /* Accent colors - keep consistent */
    --accent-primary: #4a90e2;
    --accent-primary-hover: #3a7bc8;
    --accent-gradient-start: #667eea;
    --accent-gradient-end: #764ba2;

    /* Border colors */
    --border-primary: #e0e0e0;
    --border-secondary: #d0d0d0;
    --border-tertiary: #c0c0c0;
    --border-hover: #b0b0b0;

    /* Card backgrounds */
    --card-gradient-start: #ffffff;
    --card-gradient-end: #f5f5f5;
    --card-featured-start: #e8f0fa;
    --card-featured-end: #f0f5ff;

    /* Warning/Disclaimer */
    --warning-bg: rgba(255, 200, 0, 0.15);
    --warning-border: rgba(200, 150, 0, 0.4);
    --warning-text: #5a5a5a;

    /* Shadows */
    --shadow-card: 0 8px 24px rgba(0, 0, 0, 0.1);
    --shadow-featured: 0 8px 24px rgba(74, 144, 226, 0.2);

    /* Eye component colors */
    --eye-bg: #ffffff;
    --eye-pupil: #1a1a1a;
    --eye-border: #333333;

    /* Divider */
    --divider-color: #e0e0e0;

    /* Hover */
    --bg-hover: #f0f0f0;

    /* Avatar colors */
    --avatar-primary: #C4955A;
    --avatar-secondary: #E8CFA0;
    --avatar-inner: #F0D8B0;
    --avatar-outline: #5a4a3a;
    --avatar-eye-white: #ffffff;
    --avatar-pupil: #2a2a2a;
    --avatar-eye-shine: rgba(255, 255, 255, 0.9);
    --avatar-eye-ring: #E8D8C0;
    --avatar-nose: #4a3a2a;
    --avatar-antler: #8B6E3E;
    --avatar-beak: #D4901A;

    /* Dashboard accent colors — game-inspired vibrant palette */
    --dash-streak: #EA580C;
    --dash-streak-glow: rgba(234, 88, 12, 0.18);
    --dash-record: #D97706;
    --dash-record-glow: rgba(217, 119, 6, 0.18);
    --dash-sessions: #0284C7;
    --dash-sessions-glow: rgba(2, 132, 199, 0.15);
    --dash-points: #7C3AED;
    --dash-points-glow: rgba(124, 58, 237, 0.15);
    --dash-success: #16A34A;
    --dash-success-glow: rgba(22, 163, 74, 0.15);
    --dash-ring-track: #e0e0e0;
    --dash-ring-fill: #16A34A;
    --dash-bar-ghost: #e8e8e8;
    --dash-bar-fill: var(--accent-primary);
    --dash-bar-today: #16A34A;
    --dash-badge-locked-bg: #f5f5f5;
    --dash-badge-locked-border: #e0e0e0;
    --dash-badge-new-glow: rgba(217, 119, 6, 0.45);
    --dash-badge-new-glow-wide: rgba(217, 119, 6, 0.12);
    --dash-tooltip-bg: #333333;
    --dash-tooltip-text: #ffffff;
    --dash-warning-cta: #EA580C;

    /* Calendar heatmap — green gradient for light */
    --cal-level-0-bg: #f0f0f0;
    --cal-level-0-text: var(--text-muted);
    --cal-level-1-bg: #c8e6c9;
    --cal-level-1-text: #2e7d32;
    --cal-level-2-bg: #66bb6a;
    --cal-level-2-text: #ffffff;
    --cal-level-3-bg: #43a047;
    --cal-level-3-text: #ffffff;
    --cal-level-4-bg: #2e7d32;
    --cal-level-4-text: #ffffff;
}

/* Sepia theme - warm tones, reduces blue light, easier on eyes */
[data-theme="sepia"] {
    /* Background colors - warm beige/cream tones */
    --bg-primary: #f4f1ea;
    --bg-secondary: #faf8f3;
    --bg-card: #ffffff;
    --bg-tertiary: #ebe7de;
    --bg-overlay: rgba(244, 241, 234, 0.95);
    --bg-overlay-light: rgba(244, 241, 234, 0.8);

    /* Text colors - warm browns */
    --text-primary: #3a3226;
    --text-secondary: #5c4f3a;
    --text-tertiary: #756a55;
    --text-muted: #8a7a5e;
    --text-muted-dark: #9e8f73;

    /* Accent colors - warm goldenrod/amber */
    --accent-primary: #b8860b;
    --accent-primary-hover: #9a7209;
    --accent-gradient-start: #c9a959;
    --accent-gradient-end: #8b6f47;

    /* Border colors - warm grays */
    --border-primary: #d4cfc4;
    --border-secondary: #c9c3b8;
    --border-tertiary: #beb8ad;
    --border-hover: #a69e93;

    /* Card backgrounds */
    --card-gradient-start: #faf8f3;
    --card-gradient-end: #f0ede4;
    --card-featured-start: #f5f0e3;
    --card-featured-end: #ebe6d9;

    /* Warning/Disclaimer */
    --warning-bg: rgba(184, 134, 11, 0.12);
    --warning-border: rgba(154, 114, 9, 0.3);
    --warning-text: #5c4f3a;

    /* Shadows - warm tinted */
    --shadow-card: 0 8px 24px rgba(58, 50, 38, 0.12);
    --shadow-featured: 0 8px 24px rgba(184, 134, 11, 0.2);

    /* Eye component colors */
    --eye-bg: #faf8f3;
    --eye-pupil: #3a3226;
    --eye-border: #8a7a5e;

    /* Divider */
    --divider-color: #d4cfc4;

    /* Avatar colors */
    --avatar-primary: #A0845A;
    --avatar-secondary: #C8B088;
    --avatar-inner: #D8C4A0;
    --avatar-outline: #5c4f3a;
    --avatar-eye-white: #faf8f3;
    --avatar-pupil: #3a3226;
    --avatar-eye-shine: rgba(255, 255, 255, 0.8);
    --avatar-eye-ring: #D4C4A0;
    --avatar-nose: #5c4f3a;
    --avatar-antler: #7B5E2E;
    --avatar-beak: #C88A18;

    /* Additional sepia-specific for hover states */
    --bg-hover: #ebe7de;

    /* Dashboard accent colors — warm gamification palette */
    --dash-streak: #BF5B00;
    --dash-streak-glow: rgba(191, 91, 0, 0.2);
    --dash-record: #C88A18;
    --dash-record-glow: rgba(200, 138, 24, 0.22);
    --dash-sessions: #5D4E37;
    --dash-sessions-glow: rgba(93, 78, 55, 0.15);
    --dash-points: #7B5E2E;
    --dash-points-glow: rgba(123, 94, 46, 0.18);
    --dash-success: #558B2F;
    --dash-success-glow: rgba(85, 139, 47, 0.18);
    --dash-ring-track: #d4cfc4;
    --dash-ring-fill: #8BC34A;
    --dash-bar-ghost: #d4cfc4;
    --dash-bar-fill: var(--accent-primary);
    --dash-bar-today: #8BC34A;
    --dash-badge-locked-bg: #e5e0d5;
    --dash-badge-locked-border: #c9c3b8;
    --dash-badge-new-glow: rgba(200, 138, 24, 0.5);
    --dash-badge-new-glow-wide: rgba(200, 138, 24, 0.15);
    --dash-tooltip-bg: #3a3226;
    --dash-tooltip-text: #faf8f3;
    --dash-warning-cta: #BF5B00;

    /* Calendar heatmap — amber gradient for sepia */
    --cal-level-0-bg: #ebe7de;
    --cal-level-0-text: var(--text-muted);
    --cal-level-1-bg: #f0e6c8;
    --cal-level-1-text: #8B6914;
    --cal-level-2-bg: #C8A44A;
    --cal-level-2-text: #3a3226;
    --cal-level-3-bg: #A0845A;
    --cal-level-3-text: #faf8f3;
    --cal-level-4-bg: #7B5E2E;
    --cal-level-4-text: #faf8f3;
}

/* Respect system preference for first-time visitors */
@media (prefers-color-scheme: light) {
    :root:not([data-theme]) {
        /* Background colors */
        --bg-primary: #f8f9fa;
        --bg-secondary: #ffffff;
        --bg-card: #ffffff;
        --bg-tertiary: #f0f0f0;
        --bg-overlay: rgba(255, 255, 255, 0.95);
        --bg-overlay-light: rgba(255, 255, 255, 0.8);

        /* Text colors */
        --text-primary: #1a1a1a;
        --text-secondary: #444444;
        --text-tertiary: #666666;
        --text-muted: #888888;
        --text-muted-dark: #777777;

        /* Border colors */
        --border-primary: #e0e0e0;
        --border-secondary: #d0d0d0;
        --border-tertiary: #c0c0c0;
        --border-hover: #b0b0b0;

        /* Card backgrounds */
        --card-gradient-start: #ffffff;
        --card-gradient-end: #f5f5f5;
        --card-featured-start: #e8f0fa;
        --card-featured-end: #f0f5ff;

        /* Warning/Disclaimer */
        --warning-bg: rgba(255, 200, 0, 0.15);
        --warning-border: rgba(200, 150, 0, 0.4);
        --warning-text: #5a5a5a;

        /* Shadows */
        --shadow-card: 0 8px 24px rgba(0, 0, 0, 0.1);
        --shadow-featured: 0 8px 24px rgba(74, 144, 226, 0.2);

        /* Eye component colors */
        --eye-bg: #ffffff;
        --eye-pupil: #1a1a1a;
        --eye-border: #333333;

        /* Divider */
        --divider-color: #e0e0e0;

        /* Avatar colors */
        --avatar-primary: #C4955A;
        --avatar-secondary: #E8CFA0;
        --avatar-inner: #F0D8B0;
        --avatar-outline: #5a4a3a;
        --avatar-eye-white: #ffffff;
        --avatar-pupil: #2a2a2a;
        --avatar-eye-shine: rgba(255, 255, 255, 0.9);
        --avatar-eye-ring: #E8D8C0;
        --avatar-nose: #4a3a2a;
        --avatar-antler: #8B6E3E;
        --avatar-beak: #D4901A;

        /* Dashboard accent colors — game-inspired vibrant palette */
        --dash-streak: #EA580C;
        --dash-streak-glow: rgba(234, 88, 12, 0.18);
        --dash-record: #D97706;
        --dash-record-glow: rgba(217, 119, 6, 0.18);
        --dash-sessions: #0284C7;
        --dash-sessions-glow: rgba(2, 132, 199, 0.15);
        --dash-points: #7C3AED;
        --dash-points-glow: rgba(124, 58, 237, 0.15);
        --dash-success: #16A34A;
        --dash-success-glow: rgba(22, 163, 74, 0.15);
        --dash-ring-track: #e0e0e0;
        --dash-ring-fill: #16A34A;
        --dash-bar-ghost: #e8e8e8;
        --dash-bar-fill: var(--accent-primary);
        --dash-bar-today: #16A34A;
        --dash-badge-locked-bg: #f5f5f5;
        --dash-badge-locked-border: #e0e0e0;
        --dash-badge-new-glow: rgba(217, 119, 6, 0.45);
        --dash-badge-new-glow-wide: rgba(217, 119, 6, 0.12);
        --dash-tooltip-bg: #333333;
        --dash-tooltip-text: #ffffff;
        --dash-warning-cta: #EA580C;

        /* Hover */
        --bg-hover: #f0f0f0;

        /* Calendar heatmap — green gradient */
        --cal-level-0-bg: #f0f0f0;
        --cal-level-0-text: var(--text-muted);
        --cal-level-1-bg: #c8e6c9;
        --cal-level-1-text: #2e7d32;
        --cal-level-2-bg: #66bb6a;
        --cal-level-2-text: #ffffff;
        --cal-level-3-bg: #43a047;
        --cal-level-3-text: #ffffff;
        --cal-level-4-bg: #2e7d32;
        --cal-level-4-text: #ffffff;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/theme.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,8BAA8B;;AAE9B;IACI,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,sCAAsC;;IAEtC,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;IACrB,0BAA0B;;IAE1B,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;;IAE9B,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;;IAEvB,qBAAqB;IACrB,8BAA8B;IAC9B,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;;IAE5B,uBAAuB;IACvB,oCAAoC;IACpC,wCAAwC;IACxC,uBAAuB;;IAEvB,YAAY;IACZ,6CAA6C;IAC7C,sDAAsD;;IAEtD,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;;IAErB,YAAY;IACZ,wBAAwB;;IAExB,UAAU;IACV,mBAAmB;;IAEnB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,4CAA4C;IAC5C,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,sBAAsB;;IAEtB,4DAA4D;IAC5D,sBAAsB;IACtB,4CAA4C;IAC5C,sBAAsB;IACtB,0CAA0C;IAC1C,wBAAwB;IACxB,6CAA6C;IAC7C,sBAAsB;IACtB,4CAA4C;IAC5C,uBAAuB;IACvB,4CAA4C;IAC5C,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;IACtC,yBAAyB;IACzB,+BAA+B;IAC/B,mCAAmC;IACnC,6CAA6C;IAC7C,mDAAmD;IACnD,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;;IAE3B,+CAA+C;IAC/C,qCAAqC;IACrC,qCAAqC;IACrC,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,uCAAuC;IACvC,4CAA4C;;IAE5C,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;IACrB,0BAA0B;;IAE1B,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;;IAE9B,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;;IAEvB,qBAAqB;IACrB,8BAA8B;IAC9B,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;;IAE5B,uBAAuB;IACvB,qCAAqC;IACrC,wCAAwC;IACxC,uBAAuB;;IAEvB,YAAY;IACZ,4CAA4C;IAC5C,qDAAqD;;IAErD,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;;IAErB,YAAY;IACZ,wBAAwB;;IAExB,UAAU;IACV,mBAAmB;;IAEnB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,4CAA4C;IAC5C,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,sBAAsB;;IAEtB,4DAA4D;IAC5D,sBAAsB;IACtB,2CAA2C;IAC3C,sBAAsB;IACtB,2CAA2C;IAC3C,wBAAwB;IACxB,6CAA6C;IAC7C,sBAAsB;IACtB,4CAA4C;IAC5C,uBAAuB;IACvB,4CAA4C;IAC5C,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;IACtC,yBAAyB;IACzB,+BAA+B;IAC/B,mCAAmC;IACnC,8CAA8C;IAC9C,mDAAmD;IACnD,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;;IAE3B,gDAAgD;IAChD,yBAAyB;IACzB,qCAAqC;IACrC,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,iEAAiE;AACjE;IACI,+CAA+C;IAC/C,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,uCAAuC;IACvC,4CAA4C;;IAE5C,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;IACrB,0BAA0B;;IAE1B,yCAAyC;IACzC,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;;IAE9B,+BAA+B;IAC/B,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;;IAEvB,qBAAqB;IACrB,8BAA8B;IAC9B,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;;IAE5B,uBAAuB;IACvB,sCAAsC;IACtC,wCAAwC;IACxC,uBAAuB;;IAEvB,0BAA0B;IAC1B,gDAAgD;IAChD,qDAAqD;;IAErD,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;;IAErB,YAAY;IACZ,wBAAwB;;IAExB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,4CAA4C;IAC5C,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,sBAAsB;;IAEtB,+CAA+C;IAC/C,mBAAmB;;IAEnB,wDAAwD;IACxD,sBAAsB;IACtB,yCAAyC;IACzC,sBAAsB;IACtB,4CAA4C;IAC5C,wBAAwB;IACxB,4CAA4C;IAC5C,sBAAsB;IACtB,2CAA2C;IAC3C,uBAAuB;IACvB,4CAA4C;IAC5C,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;IACtC,yBAAyB;IACzB,+BAA+B;IAC/B,mCAAmC;IACnC,8CAA8C;IAC9C,oDAAoD;IACpD,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;;IAE3B,gDAAgD;IAChD,yBAAyB;IACzB,qCAAqC;IACrC,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,sDAAsD;AACtD;IACI;QACI,sBAAsB;QACtB,qBAAqB;QACrB,uBAAuB;QACvB,kBAAkB;QAClB,sBAAsB;QACtB,uCAAuC;QACvC,4CAA4C;;QAE5C,gBAAgB;QAChB,uBAAuB;QACvB,yBAAyB;QACzB,wBAAwB;QACxB,qBAAqB;QACrB,0BAA0B;;QAE1B,kBAAkB;QAClB,yBAAyB;QACzB,2BAA2B;QAC3B,0BAA0B;QAC1B,uBAAuB;;QAEvB,qBAAqB;QACrB,8BAA8B;QAC9B,4BAA4B;QAC5B,8BAA8B;QAC9B,4BAA4B;;QAE5B,uBAAuB;QACvB,qCAAqC;QACrC,wCAAwC;QACxC,uBAAuB;;QAEvB,YAAY;QACZ,4CAA4C;QAC5C,qDAAqD;;QAErD,yBAAyB;QACzB,iBAAiB;QACjB,oBAAoB;QACpB,qBAAqB;;QAErB,YAAY;QACZ,wBAAwB;;QAExB,kBAAkB;QAClB,yBAAyB;QACzB,2BAA2B;QAC3B,uBAAuB;QACvB,yBAAyB;QACzB,2BAA2B;QAC3B,uBAAuB;QACvB,4CAA4C;QAC5C,0BAA0B;QAC1B,sBAAsB;QACtB,wBAAwB;QACxB,sBAAsB;;QAEtB,4DAA4D;QAC5D,sBAAsB;QACtB,2CAA2C;QAC3C,sBAAsB;QACtB,2CAA2C;QAC3C,wBAAwB;QACxB,6CAA6C;QAC7C,sBAAsB;QACtB,4CAA4C;QAC5C,uBAAuB;QACvB,4CAA4C;QAC5C,0BAA0B;QAC1B,yBAAyB;QACzB,yBAAyB;QACzB,sCAAsC;QACtC,yBAAyB;QACzB,+BAA+B;QAC/B,mCAAmC;QACnC,8CAA8C;QAC9C,mDAAmD;QACnD,0BAA0B;QAC1B,4BAA4B;QAC5B,2BAA2B;;QAE3B,UAAU;QACV,mBAAmB;;QAEnB,sCAAsC;QACtC,yBAAyB;QACzB,qCAAqC;QACrC,yBAAyB;QACzB,2BAA2B;QAC3B,yBAAyB;QACzB,2BAA2B;QAC3B,yBAAyB;QACzB,2BAA2B;QAC3B,yBAAyB;QACzB,2BAA2B;IAC/B;AACJ","sourcesContent":["/* Theme CSS Variables */\n/* Dark theme is the default */\n\n:root {\n    /* Background colors */\n    --bg-primary: #000000;\n    --bg-secondary: #1a1a1a;\n    --bg-card: #111111;\n    --bg-tertiary: #0a0a0a;\n    --bg-overlay: rgba(0, 0, 0, 0.8);\n    --bg-overlay-light: rgba(0, 0, 0, 0.5);\n\n    /* Text colors */\n    --text-primary: #ffffff;\n    --text-secondary: #cccccc;\n    --text-tertiary: #aaaaaa;\n    --text-muted: #888888;\n    --text-muted-dark: #666666;\n\n    /* Accent colors */\n    --accent-primary: #4a90e2;\n    --accent-primary-hover: #6aa8ff;\n    --accent-gradient-start: #667eea;\n    --accent-gradient-end: #764ba2;\n\n    /* Border colors */\n    --border-primary: #222222;\n    --border-secondary: #2a2a2a;\n    --border-tertiary: #333333;\n    --border-hover: #4a4a4a;\n\n    /* Card backgrounds */\n    --card-gradient-start: #1a1a1a;\n    --card-gradient-end: #111111;\n    --card-featured-start: #1a2a3a;\n    --card-featured-end: #111820;\n\n    /* Warning/Disclaimer */\n    --warning-bg: rgba(255, 200, 0, 0.1);\n    --warning-border: rgba(255, 200, 0, 0.3);\n    --warning-text: #e0e0e0;\n\n    /* Shadows */\n    --shadow-card: 0 12px 32px rgba(0, 0, 0, 0.6);\n    --shadow-featured: 0 12px 32px rgba(74, 144, 226, 0.3);\n\n    /* Eye component colors */\n    --eye-bg: #ffffff;\n    --eye-pupil: #000000;\n    --eye-border: #cccccc;\n\n    /* Divider */\n    --divider-color: #333333;\n\n    /* Hover */\n    --bg-hover: #1a1a1a;\n\n    /* Avatar colors */\n    --avatar-primary: #8B6914;\n    --avatar-secondary: #C4A44A;\n    --avatar-inner: #D4B86A;\n    --avatar-outline: #4a4a4a;\n    --avatar-eye-white: #ffffff;\n    --avatar-pupil: #1a1a1a;\n    --avatar-eye-shine: rgba(255, 255, 255, 0.9);\n    --avatar-eye-ring: #D4C4A0;\n    --avatar-nose: #333333;\n    --avatar-antler: #6B4E1B;\n    --avatar-beak: #E8A020;\n\n    /* Dashboard accent colors — game-inspired vibrant palette */\n    --dash-streak: #FF6B35;\n    --dash-streak-glow: rgba(255, 107, 53, 0.35);\n    --dash-record: #FFD700;\n    --dash-record-glow: rgba(255, 215, 0, 0.3);\n    --dash-sessions: #38BDF8;\n    --dash-sessions-glow: rgba(56, 189, 248, 0.3);\n    --dash-points: #A78BFA;\n    --dash-points-glow: rgba(167, 139, 250, 0.3);\n    --dash-success: #4ADE80;\n    --dash-success-glow: rgba(74, 222, 128, 0.3);\n    --dash-ring-track: #2a2a2a;\n    --dash-ring-fill: #4ADE80;\n    --dash-bar-ghost: #2a2a2a;\n    --dash-bar-fill: var(--accent-primary);\n    --dash-bar-today: #4ADE80;\n    --dash-badge-locked-bg: #141414;\n    --dash-badge-locked-border: #2a2a2a;\n    --dash-badge-new-glow: rgba(255, 215, 0, 0.5);\n    --dash-badge-new-glow-wide: rgba(255, 215, 0, 0.15);\n    --dash-tooltip-bg: #222222;\n    --dash-tooltip-text: #ffffff;\n    --dash-warning-cta: #FB923C;\n\n    /* Calendar heatmap — green gradient for dark */\n    --cal-level-0-bg: var(--bg-secondary);\n    --cal-level-0-text: var(--text-muted);\n    --cal-level-1-bg: #1b3a1b;\n    --cal-level-1-text: #81c784;\n    --cal-level-2-bg: #2e7d32;\n    --cal-level-2-text: #ffffff;\n    --cal-level-3-bg: #43a047;\n    --cal-level-3-text: #ffffff;\n    --cal-level-4-bg: #66bb6a;\n    --cal-level-4-text: #1b3a1b;\n}\n\n/* Light theme */\n[data-theme=\"light\"] {\n    /* Background colors */\n    --bg-primary: #f8f9fa;\n    --bg-secondary: #ffffff;\n    --bg-card: #ffffff;\n    --bg-tertiary: #f0f0f0;\n    --bg-overlay: rgba(255, 255, 255, 0.95);\n    --bg-overlay-light: rgba(255, 255, 255, 0.8);\n\n    /* Text colors */\n    --text-primary: #1a1a1a;\n    --text-secondary: #444444;\n    --text-tertiary: #666666;\n    --text-muted: #888888;\n    --text-muted-dark: #777777;\n\n    /* Accent colors - keep consistent */\n    --accent-primary: #4a90e2;\n    --accent-primary-hover: #3a7bc8;\n    --accent-gradient-start: #667eea;\n    --accent-gradient-end: #764ba2;\n\n    /* Border colors */\n    --border-primary: #e0e0e0;\n    --border-secondary: #d0d0d0;\n    --border-tertiary: #c0c0c0;\n    --border-hover: #b0b0b0;\n\n    /* Card backgrounds */\n    --card-gradient-start: #ffffff;\n    --card-gradient-end: #f5f5f5;\n    --card-featured-start: #e8f0fa;\n    --card-featured-end: #f0f5ff;\n\n    /* Warning/Disclaimer */\n    --warning-bg: rgba(255, 200, 0, 0.15);\n    --warning-border: rgba(200, 150, 0, 0.4);\n    --warning-text: #5a5a5a;\n\n    /* Shadows */\n    --shadow-card: 0 8px 24px rgba(0, 0, 0, 0.1);\n    --shadow-featured: 0 8px 24px rgba(74, 144, 226, 0.2);\n\n    /* Eye component colors */\n    --eye-bg: #ffffff;\n    --eye-pupil: #1a1a1a;\n    --eye-border: #333333;\n\n    /* Divider */\n    --divider-color: #e0e0e0;\n\n    /* Hover */\n    --bg-hover: #f0f0f0;\n\n    /* Avatar colors */\n    --avatar-primary: #C4955A;\n    --avatar-secondary: #E8CFA0;\n    --avatar-inner: #F0D8B0;\n    --avatar-outline: #5a4a3a;\n    --avatar-eye-white: #ffffff;\n    --avatar-pupil: #2a2a2a;\n    --avatar-eye-shine: rgba(255, 255, 255, 0.9);\n    --avatar-eye-ring: #E8D8C0;\n    --avatar-nose: #4a3a2a;\n    --avatar-antler: #8B6E3E;\n    --avatar-beak: #D4901A;\n\n    /* Dashboard accent colors — game-inspired vibrant palette */\n    --dash-streak: #EA580C;\n    --dash-streak-glow: rgba(234, 88, 12, 0.18);\n    --dash-record: #D97706;\n    --dash-record-glow: rgba(217, 119, 6, 0.18);\n    --dash-sessions: #0284C7;\n    --dash-sessions-glow: rgba(2, 132, 199, 0.15);\n    --dash-points: #7C3AED;\n    --dash-points-glow: rgba(124, 58, 237, 0.15);\n    --dash-success: #16A34A;\n    --dash-success-glow: rgba(22, 163, 74, 0.15);\n    --dash-ring-track: #e0e0e0;\n    --dash-ring-fill: #16A34A;\n    --dash-bar-ghost: #e8e8e8;\n    --dash-bar-fill: var(--accent-primary);\n    --dash-bar-today: #16A34A;\n    --dash-badge-locked-bg: #f5f5f5;\n    --dash-badge-locked-border: #e0e0e0;\n    --dash-badge-new-glow: rgba(217, 119, 6, 0.45);\n    --dash-badge-new-glow-wide: rgba(217, 119, 6, 0.12);\n    --dash-tooltip-bg: #333333;\n    --dash-tooltip-text: #ffffff;\n    --dash-warning-cta: #EA580C;\n\n    /* Calendar heatmap — green gradient for light */\n    --cal-level-0-bg: #f0f0f0;\n    --cal-level-0-text: var(--text-muted);\n    --cal-level-1-bg: #c8e6c9;\n    --cal-level-1-text: #2e7d32;\n    --cal-level-2-bg: #66bb6a;\n    --cal-level-2-text: #ffffff;\n    --cal-level-3-bg: #43a047;\n    --cal-level-3-text: #ffffff;\n    --cal-level-4-bg: #2e7d32;\n    --cal-level-4-text: #ffffff;\n}\n\n/* Sepia theme - warm tones, reduces blue light, easier on eyes */\n[data-theme=\"sepia\"] {\n    /* Background colors - warm beige/cream tones */\n    --bg-primary: #f4f1ea;\n    --bg-secondary: #faf8f3;\n    --bg-card: #ffffff;\n    --bg-tertiary: #ebe7de;\n    --bg-overlay: rgba(244, 241, 234, 0.95);\n    --bg-overlay-light: rgba(244, 241, 234, 0.8);\n\n    /* Text colors - warm browns */\n    --text-primary: #3a3226;\n    --text-secondary: #5c4f3a;\n    --text-tertiary: #756a55;\n    --text-muted: #8a7a5e;\n    --text-muted-dark: #9e8f73;\n\n    /* Accent colors - warm goldenrod/amber */\n    --accent-primary: #b8860b;\n    --accent-primary-hover: #9a7209;\n    --accent-gradient-start: #c9a959;\n    --accent-gradient-end: #8b6f47;\n\n    /* Border colors - warm grays */\n    --border-primary: #d4cfc4;\n    --border-secondary: #c9c3b8;\n    --border-tertiary: #beb8ad;\n    --border-hover: #a69e93;\n\n    /* Card backgrounds */\n    --card-gradient-start: #faf8f3;\n    --card-gradient-end: #f0ede4;\n    --card-featured-start: #f5f0e3;\n    --card-featured-end: #ebe6d9;\n\n    /* Warning/Disclaimer */\n    --warning-bg: rgba(184, 134, 11, 0.12);\n    --warning-border: rgba(154, 114, 9, 0.3);\n    --warning-text: #5c4f3a;\n\n    /* Shadows - warm tinted */\n    --shadow-card: 0 8px 24px rgba(58, 50, 38, 0.12);\n    --shadow-featured: 0 8px 24px rgba(184, 134, 11, 0.2);\n\n    /* Eye component colors */\n    --eye-bg: #faf8f3;\n    --eye-pupil: #3a3226;\n    --eye-border: #8a7a5e;\n\n    /* Divider */\n    --divider-color: #d4cfc4;\n\n    /* Avatar colors */\n    --avatar-primary: #A0845A;\n    --avatar-secondary: #C8B088;\n    --avatar-inner: #D8C4A0;\n    --avatar-outline: #5c4f3a;\n    --avatar-eye-white: #faf8f3;\n    --avatar-pupil: #3a3226;\n    --avatar-eye-shine: rgba(255, 255, 255, 0.8);\n    --avatar-eye-ring: #D4C4A0;\n    --avatar-nose: #5c4f3a;\n    --avatar-antler: #7B5E2E;\n    --avatar-beak: #C88A18;\n\n    /* Additional sepia-specific for hover states */\n    --bg-hover: #ebe7de;\n\n    /* Dashboard accent colors — warm gamification palette */\n    --dash-streak: #BF5B00;\n    --dash-streak-glow: rgba(191, 91, 0, 0.2);\n    --dash-record: #C88A18;\n    --dash-record-glow: rgba(200, 138, 24, 0.22);\n    --dash-sessions: #5D4E37;\n    --dash-sessions-glow: rgba(93, 78, 55, 0.15);\n    --dash-points: #7B5E2E;\n    --dash-points-glow: rgba(123, 94, 46, 0.18);\n    --dash-success: #558B2F;\n    --dash-success-glow: rgba(85, 139, 47, 0.18);\n    --dash-ring-track: #d4cfc4;\n    --dash-ring-fill: #8BC34A;\n    --dash-bar-ghost: #d4cfc4;\n    --dash-bar-fill: var(--accent-primary);\n    --dash-bar-today: #8BC34A;\n    --dash-badge-locked-bg: #e5e0d5;\n    --dash-badge-locked-border: #c9c3b8;\n    --dash-badge-new-glow: rgba(200, 138, 24, 0.5);\n    --dash-badge-new-glow-wide: rgba(200, 138, 24, 0.15);\n    --dash-tooltip-bg: #3a3226;\n    --dash-tooltip-text: #faf8f3;\n    --dash-warning-cta: #BF5B00;\n\n    /* Calendar heatmap — amber gradient for sepia */\n    --cal-level-0-bg: #ebe7de;\n    --cal-level-0-text: var(--text-muted);\n    --cal-level-1-bg: #f0e6c8;\n    --cal-level-1-text: #8B6914;\n    --cal-level-2-bg: #C8A44A;\n    --cal-level-2-text: #3a3226;\n    --cal-level-3-bg: #A0845A;\n    --cal-level-3-text: #faf8f3;\n    --cal-level-4-bg: #7B5E2E;\n    --cal-level-4-text: #faf8f3;\n}\n\n/* Respect system preference for first-time visitors */\n@media (prefers-color-scheme: light) {\n    :root:not([data-theme]) {\n        /* Background colors */\n        --bg-primary: #f8f9fa;\n        --bg-secondary: #ffffff;\n        --bg-card: #ffffff;\n        --bg-tertiary: #f0f0f0;\n        --bg-overlay: rgba(255, 255, 255, 0.95);\n        --bg-overlay-light: rgba(255, 255, 255, 0.8);\n\n        /* Text colors */\n        --text-primary: #1a1a1a;\n        --text-secondary: #444444;\n        --text-tertiary: #666666;\n        --text-muted: #888888;\n        --text-muted-dark: #777777;\n\n        /* Border colors */\n        --border-primary: #e0e0e0;\n        --border-secondary: #d0d0d0;\n        --border-tertiary: #c0c0c0;\n        --border-hover: #b0b0b0;\n\n        /* Card backgrounds */\n        --card-gradient-start: #ffffff;\n        --card-gradient-end: #f5f5f5;\n        --card-featured-start: #e8f0fa;\n        --card-featured-end: #f0f5ff;\n\n        /* Warning/Disclaimer */\n        --warning-bg: rgba(255, 200, 0, 0.15);\n        --warning-border: rgba(200, 150, 0, 0.4);\n        --warning-text: #5a5a5a;\n\n        /* Shadows */\n        --shadow-card: 0 8px 24px rgba(0, 0, 0, 0.1);\n        --shadow-featured: 0 8px 24px rgba(74, 144, 226, 0.2);\n\n        /* Eye component colors */\n        --eye-bg: #ffffff;\n        --eye-pupil: #1a1a1a;\n        --eye-border: #333333;\n\n        /* Divider */\n        --divider-color: #e0e0e0;\n\n        /* Avatar colors */\n        --avatar-primary: #C4955A;\n        --avatar-secondary: #E8CFA0;\n        --avatar-inner: #F0D8B0;\n        --avatar-outline: #5a4a3a;\n        --avatar-eye-white: #ffffff;\n        --avatar-pupil: #2a2a2a;\n        --avatar-eye-shine: rgba(255, 255, 255, 0.9);\n        --avatar-eye-ring: #E8D8C0;\n        --avatar-nose: #4a3a2a;\n        --avatar-antler: #8B6E3E;\n        --avatar-beak: #D4901A;\n\n        /* Dashboard accent colors — game-inspired vibrant palette */\n        --dash-streak: #EA580C;\n        --dash-streak-glow: rgba(234, 88, 12, 0.18);\n        --dash-record: #D97706;\n        --dash-record-glow: rgba(217, 119, 6, 0.18);\n        --dash-sessions: #0284C7;\n        --dash-sessions-glow: rgba(2, 132, 199, 0.15);\n        --dash-points: #7C3AED;\n        --dash-points-glow: rgba(124, 58, 237, 0.15);\n        --dash-success: #16A34A;\n        --dash-success-glow: rgba(22, 163, 74, 0.15);\n        --dash-ring-track: #e0e0e0;\n        --dash-ring-fill: #16A34A;\n        --dash-bar-ghost: #e8e8e8;\n        --dash-bar-fill: var(--accent-primary);\n        --dash-bar-today: #16A34A;\n        --dash-badge-locked-bg: #f5f5f5;\n        --dash-badge-locked-border: #e0e0e0;\n        --dash-badge-new-glow: rgba(217, 119, 6, 0.45);\n        --dash-badge-new-glow-wide: rgba(217, 119, 6, 0.12);\n        --dash-tooltip-bg: #333333;\n        --dash-tooltip-text: #ffffff;\n        --dash-warning-cta: #EA580C;\n\n        /* Hover */\n        --bg-hover: #f0f0f0;\n\n        /* Calendar heatmap — green gradient */\n        --cal-level-0-bg: #f0f0f0;\n        --cal-level-0-text: var(--text-muted);\n        --cal-level-1-bg: #c8e6c9;\n        --cal-level-1-text: #2e7d32;\n        --cal-level-2-bg: #66bb6a;\n        --cal-level-2-text: #ffffff;\n        --cal-level-3-bg: #43a047;\n        --cal-level-3-text: #ffffff;\n        --cal-level-4-bg: #2e7d32;\n        --cal-level-4-text: #ffffff;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
